import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {AlgemeneMeldingenComponent} from './algemene-meldingen/algemene-meldingen.component';
import {AlgemeneMeldingInputComponent} from './algemene-melding-input/algemene-melding-input.component';

@NgModule({
  declarations: [
    AlgemeneMeldingenComponent,
    AlgemeneMeldingInputComponent,
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    AlgemeneMeldingenComponent,
  ],
})
export class AlgemeneMeldingModule {
}
